//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatisticsCardWithImages from '@core/components/statistics-card/StatisticsCardWithImages.vue'
import StatisticsCardLineChart from '@core/components/statistics-card/StatisticsCardLineChart.vue'
import StatisticsCardBarChart from '@core/components/statistics-card/StatisticsCardBarChart.vue'
import StatisticsCardAreaChart from '@core/components/statistics-card/StatisticsCardAreaChart.vue'
import StatisticsCardRadialBarChart from '@core/components/statistics-card/StatisticsCardRadialBarChart.vue'
import StatisticsCardSessionBarChart from '@core/components/statistics-card/StatisticsCardSessionBarChart.vue'
import StatisticsCardProfitLineChart from '@core/components/statistics-card/StatisticsCardProfitLineChart.vue'

// eslint-disable-next-line object-curly-newline
import { mdiAccountOutline, mdiCurrencyUsd, mdiTrendingUp, mdiPoll, mdiLabelVariantOutline, mdiCheck } from '@mdi/js'
import StatisticsCardVertical from '@/@core/components/statistics-card/StatisticsCardVertical.vue'
import StatisticsCardHorizontal from '@/@core/components/statistics-card/StatisticsCardHorizontal.vue'

// demos
import StatisticsCard from './CardStatisticsCard.vue'
import StatisticsTotalSales from './CardStatisticsTotalSales.vue'

export default {
  components: {
    StatisticsCardVertical,
    StatisticsCardHorizontal,
    StatisticsCardWithImages,
    StatisticsCardLineChart,
    StatisticsCardBarChart,
    StatisticsCardAreaChart,
    StatisticsCardRadialBarChart,
    StatisticsCardSessionBarChart,
    StatisticsCardProfitLineChart,

    StatisticsCard,
    StatisticsTotalSales,
  },
  setup() {
    // transparent background card
    const newCustomerOptions = {
      statTitle: 'New Customers',
      statistics: '2,856',
      change: '-10.2%',
      icon: mdiAccountOutline,
      color: 'primary',
    }

    // transparent background card
    const totalRevenueOptions = {
      statTitle: 'Total Revenue',
      statistics: '28.6k',
      change: '+25.8%',
      icon: mdiCurrencyUsd,
      color: 'success',
    }

    // transparent background card
    const newTransactions = {
      statTitle: 'New Transactions',
      statistics: '13.6k',
      change: '-25.8%',
      icon: mdiTrendingUp,
      color: 'info',
    }

    // transparent background card
    const totalProfit = {
      statTitle: 'Total Profit',
      statistics: '2,856',
      change: '+25.8%',
      icon: mdiPoll,
      color: 'warning',
    }

    // vertical card options
    const newProjectOptions = {
      statTitle: 'New Project',
      icon: mdiLabelVariantOutline,
      color: 'primary',
      subtitle: 'Yearly Project',
      statistics: '862',
      change: '-18%',
    }

    const totalProfitOptions = {
      statTitle: 'Total Profit',
      icon: mdiPoll,
      color: 'secondary',
      subtitle: 'Weekly Project',
      statistics: '$25.6k',
      change: '+42%',
    }

    const revenueOptions = {
      statTitle: 'Revenue',
      icon: mdiCurrencyUsd,
      color: 'success',
      subtitle: 'Revenue Increase',
      statistics: '$95.2k',
      change: '+12%',
    }

    const logisticsOptions = {
      statTitle: 'Logistics',
      icon: mdiCurrencyUsd,
      color: 'error',
      subtitle: 'Revenue Increase',
      statistics: '44.10k',
      change: '+12%',
    }

    const reportsOptions = {
      statTitle: 'Reports',
      icon: mdiCheck,
      color: 'warning',
      subtitle: 'System Bugs',
      statistics: '268',
      change: '-8%',
    }

    const transactionsOptions = {
      statTitle: 'Transactions',
      icon: mdiTrendingUp,
      color: 'info',
      subtitle: 'Daily Transactions',
      statistics: '1.2k',
      change: '+12%',
    }

    // card with images
    const ratingsOptions = {
      statTitle: 'Ratings',
      statistics: '13k',
      change: '+38%',
      chipText: 'Year of 2021',
      chipColor: 'primary',
      avatar: require('@/assets/images/avatars/9.png'),
      avatarWidth: '112',
    }

    const sessionsOptions = {
      statTitle: 'Sessions',
      statistics: '24.5k',
      change: '-22%',
      chipText: 'Last Week',
      chipColor: 'secondary',
      avatar: require('@/assets/images/avatars/10.png'),
      avatarWidth: '86',
    }

    const customersOptions = {
      statTitle: 'Customers',
      statistics: '2,856',
      change: '+59%',
      chipText: 'Daily Customers',
      chipColor: 'info',
      avatar: require('@/assets/images/avatars/11.png'),
      avatarWidth: '88',
    }

    const totalOrders = {
      statTitle: 'Total Orders',
      statistics: '42.5k',
      change: '+26%',
      chipText: 'Last Month',
      chipColor: 'warning',
      avatar: require('@/assets/images/avatars/12.png'),
      avatarWidth: '73',
    }

    // chart card
    const sessionBarChart = {
      statTitle: 'Sessions',
      statistics: '2,856',
      series: [
        {
          name: '2020',
          data: [45, 85, 65, 50, 70],
        },
      ],
    }

    const revenueLineChart = {
      statTitle: 'Total Revenue',
      statistics: '$35.4k',
      series: [
        {
          data: [28, 58, 40, 68],
        },
      ],
    }

    const barChartWithGap = {
      statTitle: 'Sessions',
      statistics: '4,350',
      series: [
        {
          name: 'Earning',
          data: [180, 120, 284, 180, 102],
        },
        {
          name: 'Expense',
          data: [-100, -130, -100, -60, -120],
        },
      ],
    }

    const growthAreaChart = {
      statTitle: 'Total Growth',
      statistics: '42.5k',
      series: [
        {
          name: 'Subscribers',
          data: [28, 40, 36, 52, 38, 60, 55],
        },
      ],
    }

    const salesRadialChart = {
      statTitle: 'Total Sales',
      statistics: '135k',
      series: [78],
    }

    const profitLineChart = {
      statTitle: 'Total Profit',
      statistics: '$86.4k',
      series: [
        {
          data: [0, 20, 5, 30, 15, 45],
        },
      ],
    }

    return {
      newCustomerOptions,
      totalRevenueOptions,
      newTransactions,
      totalProfit,

      // horizontal card
      newProjectOptions,
      totalProfitOptions,
      reportsOptions,
      logisticsOptions,
      revenueOptions,
      transactionsOptions,

      // card with images
      ratingsOptions,
      sessionsOptions,
      customersOptions,
      totalOrders,

      // chart
      sessionBarChart,
      revenueLineChart,
      barChartWithGap,
      growthAreaChart,
      salesRadialChart,
      profitLineChart,
    }
  },
}
